<template>
    <div :class="contaierClasses">
        <label v-bind:for="id" :class="labelClasses">
            <input
                type="checkbox"
                :id="id"
                :true-value="1"
                :false-value="0"
                :checked="value === trueValue"
                v-on:change="onInput"
                v-bind="$attrs"
            > {{ label }}
        </label>
    </div>
</template>

<script>
export default {

    name: 'InputCheckbox',

    props: {
        value: '',
        id: {
            type: String,
            default: () => { return 'input-' + Math.floor(Math.random() * 1000000000); }
        },
        label: String,
        inline: {
            type: Boolean,
            default: false
        },
        inputSize: String,
        trueValue: {
            type: [String,Number,Boolean],
            default: 1
        },
        falseValue: {
            type: [String,Number,Boolean],
            default: 0
        },
    },

    computed: {
        contaierClasses() {
            const classes = ['checkbox']
            if(this.inline) {
                classes.push('checkbox-inline')
            }
            return classes.join(' ')
        },

        labelClasses() {
            const classes = ['label']
            if (this.inputSize) {
                classes.push('is-' + this.inputSize)
            }
            return classes.join(' ')
        },
    },

    methods: {
        onInput(event) {
            this.$emit('input', event.target.checked ? this.trueValue : this.falseValue)
        },
    },
}
</script>

<style lang="scss" scoped>
.checkbox-inline {
    padding-left: 0;
    padding-right: 15px;
}
</style>
